import { useState, useEffect } from 'react';
import { authAPI } from '../api/api';

export const usePermissions = () => {
  const [permissions, setPermissions] = useState({
    can_see_rental_fee: false,
    can_see_map: false,
    can_see_obd: false,
    can_see_documents: false,
    can_see_ordered_cars: false,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPermissions = () => {
      try {
        const user = authAPI.getCurrentUser();
        if (user) {
          const newPermissions = {
            can_see_rental_fee: user.can_see_rental_fee || false,
            can_see_map: user.can_see_map || false,
            can_see_obd: user.can_see_obd || false,
            can_see_documents: user.can_see_documents || false,
            can_see_ordered_cars: user.can_see_ordered_cars || false,
          };
          setPermissions(newPermissions);
        }
      } catch (error) {
        console.error('Error loading permissions:', error);
      } finally {
        setLoading(false);
      }
    };

    loadPermissions();


    const handleStorageChange = () => {
      loadPermissions();
    };

    window.addEventListener('storage', handleStorageChange);
    

    const checkUserChanges = setInterval(() => {
      const currentUser = authAPI.getCurrentUser();
      if (currentUser) {
        const newPermissions = {
          can_see_rental_fee: currentUser.can_see_rental_fee || false,
          can_see_map: currentUser.can_see_map || false,
          can_see_obd: currentUser.can_see_obd || false,
          can_see_documents: currentUser.can_see_documents || false,
          can_see_ordered_cars: currentUser.can_see_ordered_cars || false,
        };

        setPermissions(prev => {
          if (JSON.stringify(prev) !== JSON.stringify(newPermissions)) {
            return newPermissions;
          }
          return prev;
        });
      }
    }, 2000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(checkUserChanges);
    };
  }, []);

  return { permissions, loading };
};
